@use "variables" as *;

.name {
  height: 100%;
  text-align: center;
  font-size: $fontSize-xs;
  padding: $spacing-s;
  word-wrap: anywhere;
}

.skeleton {
  width: 100%;
  border-radius: 20px;
}
